import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { ModalProvider } from "@/context/ModalContext";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Manifesto } from "@/components/Manifesto";
import { Products } from "@/components/Products";
import { Consumers } from "@/components/Consumers";
import { Business } from "@/components/Business";
import { WhyStraight } from "@/components/WhyStraight";
import { Ecosystem } from "@/components/Ecosystem";
import { CTA } from "@/components/CTA";
import { Footer } from "@/components/Footer";
import { WaitlistDialog } from "@/components/WaitlistDialog";
import { ContactDialog } from "@/components/ContactDialog";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <ModalProvider>
        <div className="App bg-white">
          <Nav />
          <main>
            <Hero />
            <Manifesto />
            <Products />
            <Consumers />
            <Business />
            <WhyStraight />
            <Ecosystem />
            <CTA />
          </main>
          <Footer />
          <WaitlistDialog />
          <ContactDialog />
        </div>
        <Toaster position="bottom-right" theme="light" richColors />
      </ModalProvider>
    </ReactLenis>
  );
}

export default App;
